import script from "./teleportTo.vue?vue&type=script&lang=js"
export * from "./teleportTo.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__